import { render, staticRenderFns } from "./StatChart.vue?vue&type=template&id=c60381d8"
import script from "./StatChart.vue?vue&type=script&lang=js"
export * from "./StatChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports